"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tappedMakeOffer = void 0;

var _Schema = require("../../Schema");

/**
 * A user tapped the make offer button in an inquiry
 *
 * @example
 * ```
 * tappedMakeOffer("123")
 * ```
 *
 */
var tappedMakeOffer = function tappedMakeOffer(id) {
  return {
    action: _Schema.ActionType.tappedMakeOffer,
    context_owner_type: _Schema.OwnerType.conversation,
    impulse_conversation_id: id
  };
};

exports.tappedMakeOffer = tappedMakeOffer;